import { useMemo } from 'react';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import { queryClient } from '@/core/react-query';

import { useUser } from './core/user';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  context: {
    queryClient,
    user: undefined!, // Provided via RouterProvider
  },
  notFoundMode: 'root',
  routeTree,
});

export function Router() {
  const { user } = useUser();

  const context = useMemo(() => ({ queryClient, user }), [user]);

  return <RouterProvider context={context} router={router} />;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
